// This is only for StructureLPlus
export const PADDING_STRUCTURE = 32
export const MIN_WIDTH = 416
